import { render } from "./OpenSearch.vue?vue&type=template&id=e3c36918"
import script from "./OpenSearch.vue?vue&type=script&lang=ts"
export * from "./OpenSearch.vue?vue&type=script&lang=ts"
script.render = render

export default script